import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import AcceptedTerms from './accepted-terms';

const isHostBookingExpired = ({ booking }) => {
  return (
    <Box>
      <AcceptedTerms booking={booking} />
    </Box>
  );
};

isHostBookingExpired.propTypes = {
  booking: PropTypes.shape({}).isRequired,
};

export default isHostBookingExpired;
